import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { ScreenSizeService } from "../../../core/services/screen-size.service";
import { CommonModule, ViewportScroller } from "@angular/common";

@Component({
    selector: 'app-navigation-footer',
    standalone: true,
    imports: [
        RouterLink,
        RouterLinkActive,
        CommonModule
    ],
    templateUrl: './navigation-footer.component.html',
    styleUrl: './navigation-footer.component.scss'
})
export class NavigationFooterComponent {
    private viewportScroller = inject(ViewportScroller);

    scrollToTop() {
        this.viewportScroller.scrollToPosition([0, 0]);
    }
}
